import React, { useContext, useEffect, useState } from "react";
import { Modal, Button, Form, Container, Row, Col } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SessionContext } from "../SessionProvider";

const VehicleAdd = ({ show, onHide, onNewRecordCreated }) => {
  const { selectedSessionId, setSelectedSessionId } = useContext(SessionContext);
  const initialFormData = {
    driver_id: "",
    vehicle_no: "",
    type: "",
    seating_capacity: "",
    status: null,
    end_point: "",
    session_id : selectedSessionId,
  };
  const [formData, setFormData] = useState(initialFormData);
  const [driverOptions, setDriverOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [sessionYear, setSessionYear] = useState([]);
  console.log("handle Submit =1= ",formData)
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      console.log("handle Submit == ",formData)
      if (
        !formData.hasOwnProperty("type") || 
        !formData.hasOwnProperty("vehicle_no") || 
        !formData.hasOwnProperty("session_id") ||
        !formData.status ||
        formData.type.trim() === "" || formData.vehicle_no.trim() === "" || formData.session_id.trim() === "") {
        toast.error("Missing required fields");
        return;
      }
      const result = await schoolApi.createVehicle(formData);
      if (result.success) {
        onHide();
        onNewRecordCreated();
        setFormData(initialFormData);
        return toast.success(result.message);
      }
    } catch (error) {
      return toast.error(error.response.data.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    setFormData((prev) => ({...prev , session_id : selectedSessionId}));
  }, [selectedSessionId]);

  useEffect(() => {
    async function getSessions() {
      try {
        const sessions = await schoolApi.fetchSessions();
        console.log("sessions data == ",sessions)
        if (sessions.success) {
          setSessionYear(sessions.result);
        } else {
          setSessionYear([]);
        }
      } catch (err) {
        toast.error("An error occurred while fetching sessions.");
        setSessionYear([]);
      }
    }
    getSessions();
  }, []);

  useEffect(() => {
    async function fetchDrivers() {
      try {
        const drivers = await schoolApi.fetchDrivers();
       
        if (drivers.success) {
          const driverOptions = drivers?.drivers?.map((driver) => ({
            value: driver?.id,
            label: driver?.staffname,
          }));
          driverOptions?.unshift({ value: "", label: "Select Driver" });
          setDriverOptions(driverOptions);

        }
      } catch (error) {

        setDriverOptions([]);

      }
    }
    fetchDrivers();
  }, []);

  useEffect(() => {
    async function fetchLocations() {
      try {
        const locations = await schoolApi.getAllLocation();
       
        if (locations.success) {
          const locationOptions = locations.result.map((location) => ({
            value: location.id,
            label: location.location,
          }));
          locationOptions.unshift({ value: "", label: "Select End Point" });
          setLocationOptions(locationOptions);
        }
      } catch (error) {
        setLocationOptions([]);
      }
    }

    fetchLocations();
  }, []);

  return (
    <>
      <Modal
        show={show}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-dialog-scrollable"
        onHide={() => {
          onHide();
          setFormData(initialFormData);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>New Vehicle</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container className="view-form">
            <Form onSubmit={handleSubmit}>
              <Row name="row1">
                <Col lg={6}>
                  <Form.Group>
                    <Form.Label>Vehicle Type</Form.Label>
                    <Form.Select
                      required
                      name="type"
                      value={formData.type}
                      placeholder="Select Vehical Type"
                      onChange={handleChange}
                    >
                      <option value="">-- Select Vehical Type--</option>
                      <option value="bus">Bus</option>
                      <option value="van">Van</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group>
                    <Form.Label>Vehicle Driver</Form.Label>
                    <Form.Select
                      placeholder="Select Driver"
                      name="driver_id"
                      onChange={handleChange}
                      value={
                        formData.driver_id !== "" ? formData.driver_id : null
                      }
                    >
                      {driverOptions.map((res) => (
                        <option key={res.value} value={res.value}>
                          {res.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row name="row2">
                <Col lg={6}>
                  <Form.Group>
                    <Form.Label htmlFor="formBasicVehicleNumber">
                      Vehicle Number
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="vehicle_no"
                      placeholder="Enter Vehicle Number"
                      value={formData.vehicle_no}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group>
                    <Form.Label>End Point</Form.Label>
                    <Form.Select
                      placeholder="Select End point"
                      name="end_point"
                      onChange={handleChange}

                      value={
                        formData.end_point?.value !== ""
                          ? formData.end_point?.value
                          : formData.end_point
                      }
                    >
                      {}
                      {locationOptions.map((res) => (
                        <option key={res.value} value={res.value}>
                          {res.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row name="row3">
                <Col lg={6}>
                  <Form.Group>
                    <Form.Label>Vehicle Capacity</Form.Label>
                    <Form.Control
                      type="phone"
                      name="seating_capacity"
                      placeholder="Vehicle Capacity"
                      value={formData.seating_capacity}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          seating_capacity: e.target.value.replace(/\D/g, ""),
                        })
                      }
                    />
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group>
                    <Form.Label>Status</Form.Label>

                    <Form.Select
                      name="Status"
                      value={formData.status}
                      required
                      onChange={(e) =>
                        setFormData({ ...formData, status: e.target.value })
                      }

                    >
                      <option value="">--select status--</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">InActive</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group>
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicSession"
                    >
                      Session
                    </Form.Label>
                    <Form.Select
                      required
                      name="session_id"
                      value={formData.session_id}
                      onChange={handleChange}
                    >
                      <option value="">-- Select Session --</option>
                      {sessionYear.map((session) => (
                        <option key={session.id} value={session.id}>
                          {session.year}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              onHide();
              setFormData(initialFormData);
            }}
          >
            Cancel
          </Button>
          <Button variant="primary" type="submit" onClick={handleSubmit}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
      {}
    </>
  );
};

export default VehicleAdd;
